// A ‘.tsx’ file enables JSX support in the TypeScript compiler, 
// for more information see the following page on the TypeScript wiki:
// https://github.com/Microsoft/TypeScript/wiki/JSX

import React, { createRef } from 'react';
interface NumberPickerProps extends React.PropsWithChildren<{}> {
    value: number;
    onChange: (value: number) => void;
    min?: number;
    max?: number;
    width?: string;
    height?: string;
}

interface NumberPickerState {
    
}

class NumberPicker extends React.Component<NumberPickerProps, NumberPickerState> {
    _numberPickerRef = createRef<HTMLInputElement>();
    
    constructor(props: NumberPickerProps) {
        super(props);

    }

    private _onSelectionChanged = (e: any) => {
        this.props.onChange(e.value);
    }

    componentDidMount() {
        this._setOptions(this.props);
    }

    render() {
        return (<input type='text' ref={this._numberPickerRef} />);
    }

    shouldComponentUpdate(nextProps: NumberPickerProps, nextState: any) {
        // Never update this component...
        return false;
    }

    UNSAFE_componentWillReceiveProps(nextProps: NumberPickerProps) {
        this._setOptions(nextProps);

    }

    private _setOptions = (props: NumberPickerProps) => {
        var optionsObj: any = {
            value: props.value,
            change: this._onSelectionChanged,
            locale: InovxLoader.getSyncfusionLocale()
        };

        if (typeof props.min === 'number') {
            optionsObj.minValue = props.min;
        }

        if (typeof this.props.max === 'number') {
            optionsObj.maxValue = props.max;
        }

        if (this.props.width) {
            optionsObj.width = props.width;
        }

        if (this.props.height) {
            optionsObj.height = props.height;
        }

        var container = ($(this._numberPickerRef.current) as any).ejNumericTextbox(optionsObj);
    }
}

export default NumberPicker;